import React, { useState, useRef, useEffect } from 'react';
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";

import {useAppContext, useModalsContext, withAppContext } from '../../contexts/AppContext';
import './HorisontalCategoryPicker.css';
import { Link } from 'react-router-dom';



const HorisontalCategoryPicker = (props) => {
  const appContext = useAppContext();
  const appRef = appContext.appRef.current;
  const modalsContext = useModalsContext();
  let categories = (props.categories) ? { ...props.categories } : { ...(appRef.state.categories?.categories || {}) };
  let categoriesOrder = appRef.state.categories?.order_by || [];
  let categoryKeys = categoriesOrder;
  const addHome = props.addHome ? true : false;
  const showImages = props.showImages ? true : false;
  const flag = props.flag ? props.flag : null;

  if (addHome && categoryKeys.indexOf('home') === -1) {
    categories = { home: { category: i18n.t('pagesMenuHome'), url: '' }, ...categories };
    categoryKeys = ['home', ...categoryKeys];
    categoriesOrder = ['home', ...categoriesOrder];
  }

  const getActiveKey = () => {
    if (appRef.state.category_picker_active_key !== undefined) {
      if(appRef.state.category_picker_active_key=='home' && !addHome){
        return categoryKeys.length > 0 ? categoriesOrder[0] : null;
      }else{
        return appRef.state.category_picker_active_key;
      }
    }
    return null; // Default value if not set
  }

  const activeKey = getActiveKey();
  
  const itemRefs = useRef({});
  const underlineRef = useRef(null);

  useEffect(() => {

      if (!activeKey || !itemRefs.current[activeKey]) return;
      const el = itemRefs.current[activeKey];

      const parent = el.closest('.horisontal-category-picker');
      const rect = el.getBoundingClientRect();
      const parentRect = parent.getBoundingClientRect();

      const left = rect.left - parentRect.left + parent.scrollLeft + 10;
      const width = rect.width - 20;

      if (underlineRef.current) {
          underlineRef.current.style.transform = `translateX(${left}px)`;
          underlineRef.current.style.width = `${width}px`;
      }

  }, [activeKey, categoryKeys, appRef.state.categories]); // Depend on categories as well

  const handleClick = (key, category) => {
    const currentIdx = categoryKeys.indexOf(activeKey);
    const newIdx = categoryKeys.indexOf(key);
    
    let direction = null;
    
    if (newIdx > currentIdx) direction = 'left';
    else if (newIdx < currentIdx) direction = 'right';

    if (appRef.setState) {
      appRef.setState({ category_picker_active_key: key });
    }
    window.location.hash = category.url;
    window.dispatchEvent(new CustomEvent('categorySlideDirection', { detail: direction }));
  };


    return (
      <div className={'horisontal-category-picker'+(showImages ? ' show-images' : ' header-line')} style={{position: 'relative'}}>
        {categoriesOrder.map((key, idx) => {
          const category = categories[key];
          const isActive = activeKey === key || (!activeKey && idx === 0);
          return (
            <span
              key={key}
              className={`horisontal-category-item${isActive ? ' active' : ''}`}
            >
              <Link
                ref={el => itemRefs.current[key] = el}
                data-type='home'
                to={'#' + category.url}
                title=''
                onClick={() => handleClick(key,category)}
              >
                {showImages ? 
                  (category.app_category_image ? <img src={process.env.REACT_APP_API_SERVER_URL+'upload_files/categories/'+category.app_category_image} alt={category.category} /> : <span className="no-image-placeholder"></span>)
                : ''}
                <span>{category.category}</span>
              </Link>
            </span>
          );
        })}
        <div className="underline" ref={underlineRef}></div>
      </div>
    );
};

export default withAppContext(HorisontalCategoryPicker);